// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap___qa6T","actionsCol":"EnrolledClinics_actionsCol__2yNrI"};